module.exports = __webpack_public_path__ + "static/media/concept-energy-label-g.fd309def.svg";